// @ts-nocheck
import { Box, Typography } from "@mui/material";
import _ from "lodash";
import moment from "moment";
import { pick } from "radash";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import AppointmentScheduler from "src/components/RegistrationProgressComponents/FormScheduleAppointmentSelectDate";
import AuthService from "src/services/authService";
import UserService from "src/services/userService";
import { useQuery } from "src/services/utils";

const ScheduleAppointment = (props: {
  state: string;
  timeZone?: string;
  providerId?: string | null;
  providerIds?: string[];
  hideButtons: boolean;
  onNoAvailability?: () => void;
  onSelect: (data: any) => void;
}) => {
  const { user } = AuthService.getAuth();
  const query = useQuery();
  const history = useHistory();
  const dispatch = useDispatch();

  const [availData, setAvailData] = useState(null);
  const emptySlots = _.isEmpty(availData?.availableSlots);

  const [fetching, setFetching] = useState<boolean>(true);
  const defaultTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [state, setState] = useState({
    showVerify: false,
    showComplete: false,
    email: "",
    base64: "",
    partner: {},
    patientState: props.state || "",
    timeZone: props.timeZone || user?.timeZone || defaultTimeZone,
    refId: null,
    insuranceCarrier: "",
    showProviderPicker: false,
    loading: false,
    provider: {},
    modal: null,
    providers: [],
    startTime: moment().format(),
    endTime: moment().add(3, "month").format(),
  });

  const setGenericState = (value: any) => {
    setState((state) => ({ ...state, ...value }));
  };

  const getPhysicianSchedule = useCallback(
    async (data) => {
      setFetching(true);
      data = {
        startTime: state.startTime,
        endTime: state.endTime,
        timeZone: state.timeZone,
        type: "pseudo",
        state: state.patientState,
        providerId: props.providerId,
        providerIds: props.providerIds,
        ...data,
      };
      try {
        let response;
        response = await UserService.getSchedule(data, true);
        if (!_.isEmpty(response.data)) {
          setAvailData(response.data);
          setGenericState({ provider: response?.data?.provider });
        }

        if (_.isEmpty(_.get(response, "data.availableSlots"))) {
          props?.onNoAvailability();
        }

        response = await UserService.getProviders(
          { state: data.state || state.patientState },
          true,
        );

        setGenericState({ providers: response?.data });
        setFetching(false);
      } catch (err) {
        setFetching(false);
        console.log(err);
      }
    },
    [state],
  );

  useEffect(() => {
    getPhysicianSchedule({
      state: state.patientState,
    });
  }, []);

  useEffect(() => {
    const insuranceCarrier = state.insuranceCarrier;
    if (insuranceCarrier) {
      UserService.updateProfile(
        { insuranceCards: [{ insuranceCarrier }] },
        user.id,
      );
    }
  }, [user?.id]);

  return (
    <>
      {!fetching && emptySlots && (
        <Box>
          <Typography>
            Thank you for choosing Ognomy Sleep for your sleep health needs.
            While we don't currently have a sleep specialist in your area,
            please complete your registration and we'll reach out as soon as one
            becomes available.
          </Typography>
        </Box>
      )}
      <div className="marketing-registration">
        {!emptySlots && (
          <AppointmentScheduler
            data={availData}
            provider={state.provider || {}}
            providers={state.providers}
            title="Sleep Medicine Consultation"
            timeZone={state.timeZone}
            // showProviderToggle={false}
            duration={40}
            onConfirm={(data) => {
              console.log(data);
              // handleHoldAppointment(data);
              // onContinue(Steps.Register);
            }}
            hideButtons={props.hideButtons}
            confirmText="Continue"
            onSelect={(data) => {
              props.onSelect({
                ...data,
                ...pick(state, [
                  "provider",
                  "providers",
                  "timeZone",
                  "startTime",
                  "endTime",
                ]),
              });

              // if (localStorage.getItem("completeRegister")) {
              //   handleHoldAppointment(data);
              //   // history.push(`/scheduling?&step=${Steps.Confirm}`);
              // }
            }}
            fetchData={(changes: FetchDataType) => {
              const { timeZone, startTime, endTime } = changes;
              if (timeZone) setGenericState({ timeZone });
              if (startTime && endTime) setGenericState({ startTime, endTime });
              getPhysicianSchedule(changes);
            }}
          />
        )}
      </div>
    </>
  );
};

export default ScheduleAppointment;
